import './quadrant.css';
import AssetImg from '../lib/asset-img';
import { useState, useEffect } from 'react';

export function FromParameters({ pageID }) {
    const [quadrantData, setQuadrantData] = useState({});

    useEffect(() => {
        if (pageID !== null) {
            setQuadrantData({
                ul: { img: `/v1/api/pages/${pageID}/parameters/ul_img/0`, text: null },
                ur: { img: `/v1/api/pages/${pageID}/parameters/ur_img/0`, text: null },
                ll: { img: `/v1/api/pages/${pageID}/parameters/ll_img/0`, text: null },
                lr: { img: `/v1/api/pages/${pageID}/parameters/lr_img/0`, text: null }
            });
            fetch(`/v1/api/pages/${pageID}/parameters/ul_text/0/$blob`)
                .then(res => res.ok ? res.text() : Promise.reject())
                .then(text => setQuadrantData(prev => ({ ...prev, ul: { ...prev.ul, text } })))
                .catch(err => console.error('Error fetching upper left text'));
            fetch(`/v1/api/pages/${pageID}/parameters/ur_text/0/$blob`)
                .then(res => res.ok ? res.text() : Promise.reject())
                .then(text => setQuadrantData(prev => ({ ...prev, ur: { ...prev.ur, text } })))
                .catch(err => console.error('Error fetching upper right text'));
            fetch(`/v1/api/pages/${pageID}/parameters/ll_text/0/$blob`)
                .then(res => res.ok ? res.text() : Promise.reject())
                .then(text => setQuadrantData(prev => ({ ...prev, ll: { ...prev.ll, text } })))
                .catch(err => console.error('Error fetching lower left text'));
            fetch(`/v1/api/pages/${pageID}/parameters/lr_text/0/$blob`)
                .then(res => res.ok ? res.text() : Promise.reject())
                .then(text => setQuadrantData(prev => ({ ...prev, lr: { ...prev.lr, text } })))
                .catch(err => console.error('Error fetching lower right text'));
        }
    }, [pageID]);

    return <Quadrant {...quadrantData} />;
}

export default function Quadrant({ ul, ur, ll, lr }) {
    return <div className="quadrant">
        <div className='upper'>
            <div className="ul">
                {ul && ul.img && <AssetImg url={ul.img} />}
                {ul && ul.text && <div className='backing' dangerouslySetInnerHTML={{ __html: ul.text }} />}
            </div>
            <div className="ur">
                {ur && ur.img && <AssetImg url={ur.img} />}
                {ur && ur.text && <div className='backing' dangerouslySetInnerHTML={{ __html: ur.text }} />}
            </div>
        </div>
        <div className='lower'>
            <div className="ll">
                {ll && ll.img && <AssetImg url={ll.img} />}
                {ll && ll.text && <div className='backing' dangerouslySetInnerHTML={{ __html: ll.text }} />}
            </div>
            <div className="lr">
                {lr && lr.img && <AssetImg url={lr.img} />}
                {lr && lr.text && <div className='backing' dangerouslySetInnerHTML={{ __html: lr.text }} />}
            </div>
        </div>
    </div>
}